<template>
  <div>
    <van-nav-bar class="backBox" :title="h5Config.textCfg.title" />
    <div class="content_box">
      <div class="login_box">
        <!-- <div class="login_title">登录</div> -->
        <van-tabs v-if="loginYuen === 1 || loginSchool === 1" v-model="active" title-active-color="#1989fa">
          <van-tab :title="h5Config.textCfg.loginTit+'账号'" v-if="loginSchool === 1">
            <van-form class="vanForm" @submit="onSubmit">
              <van-field
                class="vanInput"
                v-model="account"
                name="account"
                label=""
                :clearable="true"
                autocomplete="off"
                :placeholder="'请输入' + h5Config.textCfg.loginTit + '账号'"
                :rules="[{ required: true, message: '' }]"
              >
                <img
                  class="login_img"
                  slot="left-icon"
                  src="../assets/imgs/login_account.png"
                  alt=""
                />
              </van-field>
              <van-field
                class="vanInput"
                v-model="password"
                type="password"
                name="password"
                label=""
                :clearable="true"
                :placeholder="'请输入' + h5Config.textCfg.loginTit + '密码'"
                :rules="[{ required: true, message: '' }]"
              >
                <img
                  class="login_img"
                  slot="left-icon"
                  src="../assets/imgs/login_password.png"
                  alt=""
                />
              </van-field>
              <div v-if="h5Config.funCfg.showSVGCode" class="randomMain">
              <van-field
                class="vanInput randomBox"
                v-model="randomSVGPara"
                name="randomSVGPara"
                label=""
                clearable
                placeholder="验证码"
                :rules="[{ required: true, message: '' }]"

              >
              <img
                  class="login_img"
                  slot="left-icon"
                  src="../assets/imgs/login_yanzhengma.png"
                  alt=""
                />
                <div
                style=""
                  ref="svgContainer"
                  class="randomSVG"
                  slot="right-icon"
                  v-html="randomSVG"
                />

              </van-field>
              <span class="changeImg" @click="refreshSVG()">换一张</span>
              </div>

              <div style="margin: 2rem 1rem 1rem">
                <van-button
                  class="login_btn"
                  round
                  block
                  type="info"
                  native-type="submit"
                  >登录</van-button
                >
              </div>
            </van-form>
          </van-tab>
          <van-tab :title="h5Config.textCfg.roomName + '预约账号'" v-if="loginYuen === 1">
          <!-- <van-tab :title="h5Config.textCfg.roomName + '预约账号'" v-if="loginYuen !== 1"> -->
            <van-form class="vanForm" @submit="onSubmit">
              <van-field
                class="vanInput"
                v-model="account"
                name="account"
                label=""
                :clearable="true"
                autocomplete="off"
                placeholder="请输入账号"
                :rules="[{ required: true, message: '' }]"
              >
                <img
                  class="login_img"
                  slot="left-icon"
                  src="../assets/imgs/login_account.png"
                  alt=""
                />
              </van-field>
              <van-field
                class="vanInput"
                v-model="password"
                type="password"
                name="password"
                label=""
                :clearable="true"
                placeholder="请输入密码"
                :rules="[{ required: true, message: '' }]"
                autocomplete
              >
                <img
                  class="login_img"
                  slot="left-icon"
                  src="../assets/imgs/login_password.png"
                  alt=""
                />
              </van-field>
              <div v-if="h5Config.funCfg.showSVGCode" class="randomMain">
              <van-field
                class="vanInput randomBox"
                v-model="randomSVGPara"
                name="randomSVGPara"
                label=""
                clearable
                placeholder="验证码"
                :rules="[{ required: true, message: '' }]"

              >
              <img
                  class="login_img"
                  slot="left-icon"
                  src="../assets/imgs/login_yanzhengma.png"
                  alt=""
                />
                <div
                style=""
                  ref="svgContainer"
                  class="randomSVG"
                  slot="right-icon"
                  v-html="randomSVG"
                />

              </van-field>
              <span class="changeImg" @click="refreshSVG()">换一张</span>
              </div>

              <div style="margin: 2rem 1rem 1rem">
                <van-button
                  class="login_btn"
                  round
                  block
                  type="info"
                  native-type="submit"
                  >登录</van-button
                >
              </div>

            </van-form>
          </van-tab>
        </van-tabs>

        <!-- <div class="bind-wrap">
          <div class="bind" bindtap="startXCXLogin">
            <img
              class="bind-itme-img"
              src="../assets/imgs/wx.png"
              mode="heightFix"
            />
          </div>
        </div> -->
        <!-- 统一认证登录按钮 -->
        <div v-if="unifiedOauth" class="bind-wrap">
          <div class="bind" @click="getAuthCodeUrl">
            <img
                class="bind-itme-img"
                src="../assets/imgs/wx.png"
                mode="heightFix"
            />
          </div>
          <span class="unifiedTitle">统一登录</span>
        </div>
<!--        <div class="bottom-hint">忘记密码请联系管理员重置密码</div>-->
      </div>
      <div class="top_bg"></div>
      <div class="technical-support">{{h5Config.textCfg.title}}</div>
    </div>
  </div>
</template>
<script>
import * as api from '../api/api'
import * as common from '../api/common'
import * as utils from '../api/utils'
import md5 from 'js-md5'
import { Toast, Dialog } from 'vant'
import { mapGetters } from 'vuex'
export default {
  name: 'login',
  data () {
    return {
      account: '',
      password: '',
      loginParams: {},
      active: 0,
      loginSchool: 0,
      loginYuen: 0,
      unifiedOauth: 0,
      randomSVG: '',
      randomSVGPara: '',
      svgText: '',
      random_key: '',
      randomSVGPath1: '<path fill="#eb93a9" d="M77.37 29.84L77.39 29.85L77.51 29.97Q74.91 29.77 73.57 30.99L73.64 31.05L73.61 31.02Q72.26 32.23 72.57 34.74L72.63 34.80L72.50 34.67Q72.84 37.22 74.06 38.48L74.05 38.47L74.07 38.49Q75.10 39.78 77.23 39.70L77.30 39.77L77.26 39.73Q77.86 39.76 78.05 39.76L77.92 39.64L78.00 39.72Q81.57 39.14 81.69 34.53L81.71 34.56L81.61 34.45Q81.84 32.24 81.15 31.44L81.02 31.31L81.03 31.32Q80.01 30.08 77.46 29.93ZM80.80 41.68L80.70 41.57L80.71 41.59Q79.37 42.15 77.81 42.07L77.78 42.05L77.79 42.06Q74.08 42.38 72.79 39.79L72.73 39.74L72.86 39.87Q72.51 45.04 71.18 49.30L71.29 49.41L71.18 49.30Q69.37 49.77 67.73 50.50L67.86 50.63L67.86 50.63Q70.29 44.53 70.02 37.56L70.16 37.70L70.02 37.56Q69.82 30.78 66.93 24.72L66.94 24.73L67.01 24.80Q68.95 25.98 70.66 26.44L70.65 26.43L71.13 27.85L71.18 27.91Q71.17 28.13 71.44 29.23L71.54 29.33L71.52 29.31Q72.44 27.15 76.02 26.96L76.03 26.97L76.16 27.10Q76.92 26.95 77.80 26.95L77.83 26.98L78.28 26.93L78.33 26.98Q78.55 27.09 78.74 27.13L78.70 27.09L78.90 26.98L79.01 27.10Q81.16 27.45 81.88 27.68L81.87 27.67L81.73 27.53Q83.24 28.01 84.12 28.96L84.13 28.98L84.13 28.98Q84.95 30.14 84.91 31.55L85.00 31.64L84.86 31.50Q84.99 34.48 84.19 37.15L84.11 37.06L84.23 37.19Q83.08 40.56 80.72 41.59ZM85.00 42.22L85.02 42.21L84.97 42.15Q86.05 40.15 86.35 36.04L86.37 36.05L86.40 36.08Q86.55 34.33 86.55 33.07L86.58 33.11L86.53 33.05Q86.64 31.64 85.88 30.23L85.89 30.24L85.91 30.26Q85.32 29.64 84.83 29.26L84.90 29.33L84.70 29.02L84.63 28.83L84.46 28.55L84.51 28.60Q82.72 26.51 78.38 26.51L78.48 26.61L77.85 26.58L77.84 26.58Q73.19 26.57 71.56 28.17L71.68 28.29L71.52 28.13Q71.44 27.71 71.29 27.21L71.33 27.26L70.93 26.06L71.02 26.15Q68.58 25.57 66.37 24.09L66.25 23.97L66.20 23.92Q69.45 30.21 69.75 37.44L69.80 37.49L69.83 37.52Q70.15 44.81 67.29 51.28L67.15 51.14L69.31 50.44L69.34 50.47Q69.01 51.13 68.32 52.69L68.23 52.59L68.37 52.74Q71.03 51.63 73.35 51.28L73.33 51.26L73.43 51.36Q74.41 46.41 74.57 42.68L74.59 42.70L74.68 42.79Q75.94 44.12 79.55 44.35L79.65 44.45L79.68 44.48Q83.61 44.72 85.06 42.28L85.00 42.22ZM79.43 32.24L79.28 32.08L79.35 32.15Q80.07 32.15 81.18 32.50L81.12 32.44L81.09 32.41Q81.37 33.41 81.33 34.59L81.31 34.57L81.39 34.66Q81.41 35.59 81.22 36.23L81.14 36.15L81.14 36.15Q80.48 39.11 77.97 39.42L78.00 39.45L78.09 39.42L78.02 39.36Q77.85 39.26 77.73 39.30L77.86 39.42L77.39 39.49L77.21 39.30Q76.04 39.31 75.05 38.81L75.08 38.85L74.69 36.74L74.73 36.79Q74.60 34.48 75.89 33.46L75.92 33.48L75.88 33.45Q77.01 32.48 79.41 32.21Z"></path>'
    }
  },
  created () {
    api.removeAccessToken()
  },
  mounted () {
    this.$nextTick(() => {
      const realHeight = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight
      this.setMetaHeight(realHeight)
    })
    this.getConfig()
    this.getLoginRandom()

    this.loginParams = this.$route.query

    if (this.$route.query.code) {
      // oauth 登录
      this.oauthLogin(this.$route.query.code)
    }
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    refreshSVG () {
      this.getLoginRandom()
    },
    // 获取随机SVG图片
    getLoginRandom () {
      if (this.h5Config.funCfg.showSVGCode) {
        const para = {
          width: 100,
          height: 40
        }
        api
          .axiosRequest(api.urlList.getLoginRandom, para)
          .then((res) => {
            if (res.code === common.resCode.OK) {
              this.randomSVG = res.data
              this.random_key = res.random_key
              this.svgText = atob(res.text)
            } else {
              Dialog.alert({
                message: '未获取到验证码，点击确认重新获取'
              }).then(() => {
                // on close
                this.getLoginRandom()
              })
            }
          })
          .catch((e) => Toast.fail('请求异常', e))
      }
    },

    onSubmit (values) {
      // 判断当前输入的验证码内容是否和右侧一致
      if (this.h5Config.funCfg.showSVGCode) {
        if (this.randomSVGPara.toLowerCase() !== this.svgText.toLowerCase()) {
          Toast.fail('验证码输入有误')
          return
        }
      }

      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })
      const para = {
        account: values.account,
        pwd: md5(values.password),
        isNotToken: true
      }
      if (this.h5Config.funCfg.showSVGCode) {
        para.random_key = this.random_key
        para.random_txt = values.randomSVGPara
      }
      if (this.h5Config.funCfg.h5LoginDuration) {
        para.duration = this.h5Config.funCfg.h5LoginDuration
      }

      const tempPassword = values.password
      // return false
      // this.loginSchool = 0
      // this.loginYuen = 1
      if (this.loginSchool === 0 && this.loginYuen === 1) {
        this.pianoLogin(para, tempPassword)
      } else if (this.loginSchool === 1 && this.loginYuen === 0) {
        para.pwd = values.password

        this.unifiedLogin(para, tempPassword)
      } else {
        if (this.active === 0) {
          para.pwd = values.password

          this.unifiedLogin(para, tempPassword)
        } else {
          this.pianoLogin(para, tempPassword)
        }
      }
    },

    // 琴房账号登录
    pianoLogin (para, tempPassword) {
      api
        .axiosRequest(api.urlList.login, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            Toast.clear()

            if (res.user_info) {
              api.setAccessToken(res.access_token)
              const passwordCheck = !utils.checkPassword(tempPassword)
              let passwordCheckVal = ''
              if (passwordCheck) {
                passwordCheckVal = '1'
              } else {
                passwordCheckVal = '0'
              }
              api.setPasswordCheck(passwordCheckVal)

              this.$store.commit('USERINFO', JSON.stringify(res.user_info))
              api.setUser(JSON.stringify(res.user_info))
              // this.$store.dispatch('clearBuilding')
              if (this.h5Config && this.h5Config.funCfg && this.h5Config.funCfg.openFace) {
                this.$store.dispatch('FACE', { userInfo: res.user_info.userid })
              }
              Toast('欢迎' + para.account)
              this.goPageOrOrder()
            }
          } else {
            Toast.fail('登录失败 ' + ((common.resMSG[res.code] === undefined) ? (res.msg ? res.msg : '') : ':' + common.resMSG[res.code]))
          }
        })
        .catch((e) => console.log('Error:', e))
    },
    // 统一认证登录
    unifiedLogin (para, tempPassword) {
      api
        .axiosRequest(api.urlList.unifiedLogin, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            Toast.clear()

            if (res.user_info) {
              api.setAccessToken(res.access_token)
              // const passwordCheck = !utils.checkPassword(tempPassword)
              // let passwordCheckVal = ''
              // if (passwordCheck) {
              //   passwordCheckVal = '1'
              // } else {
              //   passwordCheckVal = '0'
              // }
              //
              // api.setPasswordCheck(passwordCheckVal)
              api.setPasswordCheck('0')

              this.$store.commit('USERINFO', JSON.stringify(res.user_info))
              api.setUser(JSON.stringify(res.user_info))
              this.$store.dispatch('FACE', { userInfo: res.user_info.userid })
              Toast('欢迎' + para.account)

              this.goPageOrOrder()
            }
          } else {
            Toast.fail('登录失败 ' + ((common.resMSG[res.code] === undefined) ? (res.msg ? res.msg : '') : ':' + common.resMSG[res.code]))
          }
        })
        .catch((e) => Toast.fail('网络出错'))
    },
    getAuthCodeUrl () {
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })

      const para = {
        channel: this.h5Config.funCfg.oauthLoginChannel
      }
      api
        .axiosRequest(api.urlList.getAuthCodeUrl, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            location.replace(res.url)
          } else {
            Toast.fail('登录失败' + ((res.msg === undefined) ? '' : ':' + res.msg))
          }
        })
        .catch((e) => Toast.fail('网络出错'))
    },
    oauthLogin (code) {
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })

      const para = {
        channel: this.h5Config.funCfg.oauthLoginChannel,
        code: code
      }
      api
        .axiosRequest(api.urlList.oauthLogin, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            Toast.clear()

            if (res.user_info) {
              api.setAccessToken(res.access_token)
              api.setPasswordCheck('0')

              this.$store.commit('USERINFO', JSON.stringify(res.user_info))
              api.setUser(JSON.stringify(res.user_info))

              // Toast('欢迎' + para.account)

              this.goPageOrOrder()
            }
          } else {
            Toast.fail('登录失败' + ((res.msg === undefined) ? '' : ':' + res.msg))
          }
        })
        .catch((e) => Toast.fail('网络出错'))
    },
    // 获取全局配置
    getConfig (val) {
      const para = {
        access_token: val || localStorage.getItem(common.keyAccessToken)
      }
      api
        .axiosRequest(common.baseUrlApiConfig + api.urlList.getConfig, para)
        .then((res) => {
          if (res && res.code === common.resCode.OK) {
            api.setConfig(JSON.stringify(res))

            if (res.login_method) {
              this.loginSchool = res.login_method.unified_auth ? 1 : 0
              this.loginYuen = res.login_method.yuen ? 1 : 0
              this.unifiedOauth = res.login_method.unified_oauth ? 1 : 0
            } else {
              this.loginSchool = 0
              this.loginYuen = 1
              this.unifiedOauth = 0
            }

            if (res) {
              this.getDayOpenTime(res)
            }
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    // 获取查询某天和对应的开放时间配置
    getDayOpenTime (res) {
      const week = new Date().getDay()
      const allConfigData = utils.refreshConfigData(week, res)

      let startEndTimeExplain = ''// 没有用到
      if (allConfigData) {
        startEndTimeExplain = allConfigData.begin_time +
          '-' + allConfigData.end_time
      }
      console.log(startEndTimeExplain)

      this.$store.commit('CONFIGINFO', JSON.stringify(allConfigData))
      api.setConfig(JSON.stringify(allConfigData))
    },
    goBackPage () {
      const para = {}
      for (const key in this.$route.query) {
        if (key !== 'page') {
          para[key] = this.$route.query[key]
        }
      }
      this.$router.push({
        path: '/' + this.$route.query.page,
        replace: true,
        query: para
      })
    },
    goPageOrOrder () {
      if (this.$route.query && this.$route.query.page) {
        this.goBackPage()
      } else {
        this.$router.replace('/order')
      }
    },
    // 设置meta高度 解决安卓浏览器软键盘弹起，占用窗口的面积把元素顶起的问题
    setMetaHeight (height) {
      document.head.querySelector("meta[name='viewport']").setAttribute('id', 'viewportMeta')
      const metaEl = document.querySelector('#viewportMeta')
      const content = 'height=' + height + ',width=device-width,initial-scale=1.0,user-scalable=no'
      metaEl.setAttribute('name', 'viewport')
      metaEl.setAttribute('content', content)
      this.$forceUpdate()
    }
  }
}
</script>
<style scoped lang="scss">
.content_box {
  .login_box {
    // position: absolute;
    // height: 430px;
    margin-left: 1rem;
    margin-right: 1rem;
    margin-top: 6.25rem;
    display: flex;
    flex-flow: column;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0px 1px 10px 1px rgba(1, 1, 1, 0.1);
    .login_title {
      margin-top: 1.25rem;
      margin-bottom: 1rem;
      font-size: 1.125rem;
      font-weight: bold;
      color: black;

      text-align: center;
    }
    /deep/ .van-tabs--line .van-tabs__wrap {
      margin-top: 1rem;
    }
    .vanForm {
      margin-top: 1rem;
    }
    .vanInput {
      // height: 40px;
      /deep/ .van-field__left-icon {
        display: flex;
        align-items: center;
        .login_img {
          width: 1rem;
          margin-left: 1rem;
          margin-right: 1rem;
          // height: 1rem;
        }
      }
    }

    .login_btn {
      font-size: 1.125rem;
      color: #fff;
      font-weight: bold;
    }
    .bind {
      margin: 0.9375rem auto auto auto;
      background-color: white;
    }
    .bind-wrap {
      text-align: center;
      margin-bottom: 1.75rem;
      .unifiedTitle {
        font-size: 0.75rem;
      }
    }
    .bind-itme-img {
      width: 2.5rem;
      height: 2.5rem;
    }
    .bottom-hint {
      margin: 2.8125rem auto 1.5625rem;
      font-size: 0.75rem;
      color: #999;
    }
    .login_item {
      box-sizing: border-box;
      display: flex;
      flex-flow: row;
      align-items: center;
      height: 3.125rem;
      margin-left: 1.5625rem;
      margin-right: 1.5625rem;
      border-bottom: 1px solid #ececec;
    }
    .loginBtn {
      height: 3.125rem;
      line-height: 3.125rem;
      text-align: center;
      margin-left: 1.5625rem;
      margin-right: 1.5625rem;
      margin-top: 2.8125rem;
      font-weight: bold;
      font-size: 1.125rem;
      color: #fff;
      border-radius: 1.5625rem;
      background-color: #007dff;
    }
  }
  .top_bg {
    width: 100%;
    height: 12.5rem;
    background: #60b3ff;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    text-align: center;
  }
  .technical-support {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 1.25rem;
    font-size: 0.75rem;
    color: #88c6ff;
  }
  /deep/ .van-tabs__line {
    background-color: #1989fa;
  }
  .randomMain{
    display: flex;
    /deep/ .van-cell{
      padding: 10px 5px 10px 16px;
    }

  .randomBox{
    /deep/ .van-field__body{
      height: 1.5rem !important;

        .randomSVG{
      display: flex !important;
      /deep/ .van-field__right-icon{
        // height: 1.875rem;
        svg{
          height: 1.875rem;
        }
      }
    }
    }

  }
  .changeImg{
    width: 3.125rem;
    font-size: .625rem;
    color: #606266;
    // margin-right: 1rem;
    display: flex;
    align-items: center;
    // line-height: 2.75rem;
  }
   }
}

</style>
